/* eslint-disable no-constant-condition */
import { Component, OnInit, ElementRef, Inject, PLATFORM_ID, Optional, DestroyRef, inject } from '@angular/core';
import { TranslocoService, getBrowserLang } from '@ngneat/transloco';
import { ErrorDialogComponent, ErrorDialogDialogData } from './home/components/dialogs/error-dialog/error-dialog.component';
import { take } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthAPIService } from './home/services/auth-api.service';
import { ShopService } from './home/services/shop.service';
import { Meta } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { REQUEST } from './tokens/tokens';
import { Request } from 'express';
import { GaService } from './home/services/ga.service';
import { CookiesService } from './home/services/cookies.service';
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from './consts';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  loader: boolean;
  backdrop = false;
  langToSet: string;
  styleSet: boolean;
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private cookiesService: CookiesService,
    public translocoService: TranslocoService,
    public dialog: MatDialog,
    public el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object,
    private authApiService: AuthAPIService,
    private shopService: ShopService,
    private meta: Meta,
    @Optional() @Inject(REQUEST) request: Request,
    private gaService: GaService
  ) {
    this.setLangByClientData(request);
    this.authApiService
      .getSessionLanguage()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(
      (response: any) => {
        if (response && response !== 'default') {
          this.langToSet = response;
          this.translocoService.setActiveLang(this.langToSet);
          this.translocoService.setDefaultLang(this.langToSet);
        }
      },
      () => {}
      );
  }

  ngOnInit(): void {
    this.gaService.initialize();
    this.cookiesService.init();
    if (isPlatformBrowser(this.platformId)) {
      this.translocoService.langChanges$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.updateLangAttr();
        });
    }
    this.initMetaListener();
  }

  setLoader(visible) {
    visible ? (this.loader = true) : (this.loader = false);
  }

  openDialog(errorText, callback?, otherText?, title?, withButton?): void {
    const data: ErrorDialogDialogData = { error: errorText, otherText: otherText, title, withButton: withButton || !!callback };
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '600px',
      data,
    });

    dialogRef.afterClosed().subscribe(() => {
      if (callback) {
        callback(true);
      }
    });
  }

  updateLangAttr() {
    const lang = document.createAttribute('lang');
    lang.value = this.translocoService.getActiveLang();
    this.el.nativeElement.parentElement.parentElement.attributes.setNamedItem(lang);
  }

  initMetaListener() {
    if (this.shopService.shop) {
      this.translocoService
        .selectTranslate('general.meta_description')
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe((text) => {
          const description = text.replace(/{{shopName}}/g, this.shopService.shop.name);
          this.meta.updateTag({ name: 'description', content: description });
        });
    }
  }

  setLangByClientData(request?: Request) {
    if (request?.headers) {
      const langsString = request.headers['accept-language'];
      const result = langsString?.split(',').find((lang) => {
        const foundLang = AVAILABLE_LANGUAGES.find(availableLang => availableLang === lang.toLowerCase());

        if (foundLang && lang.toLowerCase().includes(foundLang)) {
          this.translocoService.setActiveLang(foundLang);
          this.translocoService.setDefaultLang(foundLang);

          return true;
        }

        return false;
      });
      if (!result) {
        this.translocoService.setActiveLang(DEFAULT_LANGUAGE);
        this.translocoService.setDefaultLang(DEFAULT_LANGUAGE);
      }
    } else {
      const browserLang = getBrowserLang();
      if (!AVAILABLE_LANGUAGES.some(lang => lang === browserLang)) {
        this.langToSet = DEFAULT_LANGUAGE;
      } else {
        this.langToSet = browserLang;
      }
      this.translocoService.setActiveLang(this.langToSet);
      this.translocoService.setDefaultLang(this.langToSet);
    }
  }
}
